import type { Pixel } from "../units/Units"
import type { PDFReaderOptions } from "./PDFReaderOptions"
import type { PDFSplitResult } from "./PDFSplitter"

export type PDFConvertFunction = (
  input: PDFReaderOptions,
  resolution: Pixel
) => Promise<PDFSplitResult>
